type BrowserLocation = {
  hostname: string;
  origin: string;
};

export function resolveApiUrl(
  configuredUrl: string | undefined,
  location: BrowserLocation | undefined,
): string {
  if (configuredUrl) {
    return configuredUrl;
  }

  if (
    !location ||
    location.hostname === "localhost" ||
    location.hostname === "127.0.0.1"
  ) {
    return "http://localhost:8787";
  }

  const [applicationLabel, ...domainLabels] = location.hostname.split(".");

  if (!applicationLabel || domainLabels.length === 0) {
    throw new Error(`Cannot derive API URL from ${location.hostname}`);
  }

  const hostedEnvironment = /^insights-(preview[0-9]+|staging)$/.exec(
    applicationLabel,
  );
  const apiLabel =
    applicationLabel === "insights"
      ? "api"
      : hostedEnvironment
        ? `api-${hostedEnvironment[1]}`
        : undefined;

  if (!apiLabel) {
    throw new Error(`Cannot derive API URL from ${location.hostname}`);
  }

  const apiUrl = new URL(location.origin);
  apiUrl.hostname = [apiLabel, ...domainLabels].join(".");

  return apiUrl.origin;
}
